import { useTranslation } from "react-i18next";

import type { PhysicalFitnessAssessment } from "~/api/physicalFitnessAssessments";
import {
  CardiorespiratorySection,
  CoreMuscleEnduranceSection,
  PerformanceDetails,
  PushUpSection,
} from "./components";

interface PerformanceProps {
  lastPFA: PhysicalFitnessAssessment;
}

export const Performance = ({ lastPFA }: PerformanceProps) => {
  const { t } = useTranslation();

  return (
    <>
      <PerformanceDetails.Title value={t("patient_detail.performance")} />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <CardiorespiratorySection lastPFA={lastPFA} />
        <PushUpSection lastPFA={lastPFA} />
        <CoreMuscleEnduranceSection lastPFA={lastPFA} />
      </div>
    </>
  );
};
